module.exports = __webpack_public_path__ + "img/illegal_cut_en.6ccd3558.svg";